/**
 * Not supported on the web
 */
export function SystemBars() {
  return null
}
